import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-hidden"
}
const _hoisted_3 = {
  class: "row w-full mb-3 justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "cardbody" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { class: "mt-5 table-section" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "kpi-history-dialog-overlay"
}
const _hoisted_11 = {
  key: 0,
  class: "kpi-history-dialog-title flex items-start justify-between px-4"
}
const _hoisted_12 = { class: "kpi-history-dialog-heading" }
const _hoisted_13 = { class: "kpi-history-id" }
const _hoisted_14 = { class: "kpi-history-name" }
const _hoisted_15 = {
  key: 1,
  class: "border-b border-solid border-lightgrey mx-4"
}
const _hoisted_16 = { class: "kpi-history-body" }
const _hoisted_17 = { class: "kpi-history-popup" }
const _hoisted_18 = {
  key: 0,
  class: "kpi-history-empty-wrap"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "kpi-trend-wrap" }
const _hoisted_21 = { class: "kpi-trend-header" }
const _hoisted_22 = { class: "kpi-trend-pills" }
const _hoisted_23 = {
  key: 0,
  class: "kpi-trend-empty"
}
const _hoisted_24 = {
  key: 1,
  class: "kpi-trend-empty"
}
const _hoisted_25 = {
  key: 2,
  class: "kpi-trend-chart"
}
const _hoisted_26 = { class: "kpi-history-table-wrap" }
const _hoisted_27 = { class: "kpi-history-table w-full" }
const _hoisted_28 = {
  class: "kpi-history-date",
  colspan: "4"
}
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = {
  key: 0,
  class: "inline-flex items-center justify-center rounded h-5 w-28 text-xs font-semibold text-lightgreen bg-veryLowColor border-solid border border-lightgreen"
}
const _hoisted_31 = {
  key: 1,
  class: "inline-flex items-center justify-center rounded h-5 w-28 text-xs font-semibold text-darkred bg-veryHighColor border-solid border border-darkred"
}
const _hoisted_32 = {
  key: 2,
  class: "inline-flex items-center justify-center rounded h-5 w-28 px-2.5 text-xs font-semibold text-gray bg-lightgrey border-solid border border-lightgrey"
}
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { colspan: "3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "title" }, "KPIs", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: _normalizeClass(["flex", _ctx.columnObject ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
                }, [
                  (_ctx.columnObject)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", _hoisted_7)),
                  _cache[7] || (_cache[7] = _createTextVNode(" Filters "))
                ], 2)
              ])
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-xs mt-3" }, " This page provides a clear view of key performance indicators (KPIs) for the security controls that are adopted or activated. KPIs will help you to monitor effectiveness and gain insights to strengthen your organization's security posture. ", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_tableData, {
              class: "flex-1 min-h-0",
              tableRowData: _ctx.tableRow,
              headersData: _ctx.headers,
              departmentArr: _ctx.deptOptions,
              loadData: _ctx.dataLoading,
              columnWidthPreset: "kpi"
            }, null, 8, ["tableRowData", "headersData", "departmentArr", "loadData"]),
            (_ctx.toolTipActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showPopup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["kpi-history-dialog", { 'kpi-history-dialog--empty': !_ctx.kpiResults.length }])
            }, [
              (_ctx.kpiResults.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("h1", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.allKpis.kpi_id || _ctx.allKpis.kpiId), 1),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "kpi-history-sep" }, "|", -1)),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.allKpis.description || _ctx.allKpis.KPI), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "float-right text-3xl",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeKpiHistory && _ctx.closeKpiHistory(...args)))
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.kpiResults.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  (!_ctx.kpiResultsLoading && !_ctx.kpiResults.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "kpi-history-empty-close",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeKpiHistory && _ctx.closeKpiHistory(...args)))
                        }, _cache[12] || (_cache[12] = [
                          _createElementVNode("img", {
                            src: _imports_2,
                            class: "h-5 w-5 cursor-pointer"
                          }, null, -1)
                        ])),
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "kpi-history-empty-msg" }, "No results found", -1))
                      ]))
                    : (!_ctx.kpiResultsLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "kpi-trend-title" }, "KPI Target vs Achieved", -1)),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["kpi-trend-pill", { 'kpi-trend-pill--active': _ctx.kpiTrendTimePeriod === '20604' }]),
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setKpiTrendPeriod('20604')))
                                }, "3M", 2),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["kpi-trend-pill", { 'kpi-trend-pill--active': _ctx.kpiTrendTimePeriod === '20603' }]),
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setKpiTrendPeriod('20603')))
                                }, "6M", 2),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["kpi-trend-pill", { 'kpi-trend-pill--active': _ctx.kpiTrendTimePeriod === '' }]),
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setKpiTrendPeriod('')))
                                }, "1Y", 2),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["kpi-trend-pill", { 'kpi-trend-pill--active': _ctx.kpiTrendTimePeriod === '20605' }]),
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setKpiTrendPeriod('20605')))
                                }, "3Y", 2)
                              ])
                            ]),
                            (_ctx.kpiTrendUnavailable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, "No records found"))
                              : (!_ctx.kpiTrendHasData)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, "No records in this period"))
                                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (_openBlock(), _createBlock(_component_apexchart, {
                                      key: _ctx.kpiTrendChartKey,
                                      type: "line",
                                      height: "240",
                                      options: _ctx.kpiTrendChartOptions,
                                      series: _ctx.kpiTrendSeries
                                    }, null, 8, ["options", "series"])),
                                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "kpi-trend-legend" }, [
                                      _createElementVNode("span", { class: "kpi-trend-legend-item" }, [
                                        _createElementVNode("span", { class: "kpi-trend-legend-line kpi-trend-legend-line--target" }),
                                        _createTextVNode(" Target ")
                                      ]),
                                      _createElementVNode("span", { class: "kpi-trend-legend-item" }, [
                                        _createElementVNode("span", { class: "kpi-trend-legend-line kpi-trend-legend-line--achieved" }),
                                        _createTextVNode(" Achieved ")
                                      ])
                                    ], -1))
                                  ]))
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiResults, (obj, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "kpi-history-result-block"
                            }, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("table", _hoisted_27, [
                                  _cache[25] || (_cache[25] = _createElementVNode("colgroup", null, [
                                    _createElementVNode("col", { style: {"width":"23%"} }),
                                    _createElementVNode("col", { style: {"width":"27%"} }),
                                    _createElementVNode("col", { style: {"width":"23%"} }),
                                    _createElementVNode("col", { style: {"width":"27%"} })
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.formatResultDate(_ctx.getKpiResultGraphDate(obj))), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[16] || (_cache[16] = _createElementVNode("td", { class: "headerData" }, "Result", -1)),
                                      _createElementVNode("td", _hoisted_29, [
                                        (_ctx.getKpiPassFail(obj) === 'Pass')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.getKpiPassFail(obj)), 1))
                                          : (_ctx.getKpiPassFail(obj) === 'Fail')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.getKpiPassFail(obj)), 1))
                                            : (_ctx.getKpiPassFail(obj) === 'No Instances')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.getKpiPassFail(obj)), 1))
                                              : _createCommentVNode("", true)
                                      ]),
                                      _cache[17] || (_cache[17] = _createElementVNode("td", { class: "headerData" }, "Risk Severity", -1)),
                                      _createElementVNode("td", _hoisted_33, [
                                        (_ctx.isKpiNoInstances(obj))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode("N/A")
                                            ], 64))
                                          : (obj.severity)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["inline-flex items-center justify-center rounded h-5 w-28 px-2.5 text-xs font-semibold", _ctx.colorRiskBg(obj.severity)])
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(_ctx.colorRiskText(obj.severity))
                                                }, _toDisplayString(_ctx.getSeverityLabel(obj.severity)), 3)
                                              ], 2))
                                            : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[18] || (_cache[18] = _createElementVNode("td", { class: "headerData" }, "Target Type", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.getKpiTargetTypeDisplay(obj)), 1),
                                      _cache[19] || (_cache[19] = _createElementVNode("td", { class: "headerData" }, "Condition", -1)),
                                      _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.getKpiConditionDisplay(obj)), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[20] || (_cache[20] = _createElementVNode("td", { class: "headerData" }, "Target", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.getKpiTargetDisplay(obj)), 1),
                                      _cache[21] || (_cache[21] = _createElementVNode("td", { class: "headerData" }, "Achieved", -1)),
                                      _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.getKpiActualDisplay(obj)), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[22] || (_cache[22] = _createElementVNode("td", { class: "headerData" }, "Population", -1)),
                                      _createElementVNode("td", null, _toDisplayString(obj.population), 1),
                                      _cache[23] || (_cache[23] = _createElementVNode("td", { class: "headerData" }, "Compliant", -1)),
                                      _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.getKpiCompliantDisplay(obj)), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[24] || (_cache[24] = _createElementVNode("td", { class: "headerData" }, "Comments", -1)),
                                      _createElementVNode("td", _hoisted_37, _toDisplayString(obj.comments), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}